import React from "react";
import RoentgenStatistikk from "./RoentgenStatistikk";


const BarnebarnRoentgenStatistikk = (props) => {
    const statistikk = props.barnebarnStatistikk;
    const raseStatistikk = props.raseStatistikk;
    return (
        <div>
            <div className="dogweb-card">
                <div className="statistikk-info">
                    <div className="hunden">
                        <p><strong>Denne Hund</strong></p>
                        <p><span>Antal hvalpe:</span> {statistikk.antallAvkom}</p>

                        {
                            statistikk.gjennomsnittligAntAvkomPerAar > 100 &&
                            <p><span>Matadoravlsgrænse</span> {statistikk.matadorAntall} hvalp</p>
                        }
                        {
                            statistikk.gjennomsnittligAntAvkomPerAar < 100 &&
                            <p><span>Matadoravlsgrænse</span> ikke relevant i denne race, da den har under 100 reg./år</p>
                        }
                    </div>
                    <div className="racen">
                        <p><strong>Race sidste 10 år</strong></p>
                        <p><span>Antal hvalpe:</span> {raseStatistikk.antallAvkom} </p>

                    </div>
                </div>
            </div>

            <RoentgenStatistikk statistikk={statistikk}
                                raseStatistikk={raseStatistikk} />
        </div>

    );
};
export default BarnebarnRoentgenStatistikk;